module.exports = [[[0,6],[0,34]],[[1,3],[0,2]],[[55,0],[5,0]],[[25,0],[1,0]],[[15,0],[1,2]],[[0,3],[0,7]],[[2,4],[0,37]],[[2,2],[0,8]],[[114,1],[18,3]],[[5,6],[3,23]],[[0,1],[2,4]],[[3,1],[1,4]],[[9,0],[2,0]],[[5,3],[2,8]],[[40,2],[9,2]],[[2,2],[0,1]],[[9,0],[5,1]],[[0,3],[1,2]],[[16,2],[9,2]],[[22,2],[6,5]]]


//////////////////
// WEBPACK FOOTER
// ./src/test_data/support_mat.json
// module id = 717
// module chunks = 0